import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=63ce0418&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=ts&"
export * from "./roles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce0418",
  null
  
)

export default component.exports